export function base64urlToBytes(value) {
  const base64 = value.replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64.padEnd(base64.length + (4 - base64.length % 4) % 4, '=');
  const binary = atob(padded);
  const bytes = new Uint8Array(binary.length);

  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index);
  }

  return bytes;
}

export function bytesToBase64url(buffer) {
  const bytes = new Uint8Array(buffer);
  let binary = '';

  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });

  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

export function publicKeyRequestOptions(options) {
  return {
    ...options,
    challenge: base64urlToBytes(options.challenge),
    allowCredentials: options.allowCredentials?.map((descriptor) => ({
      ...descriptor,
      id: base64urlToBytes(descriptor.id)
    }))
  };
}

export function webAuthnAvailable() {
  return window.isSecureContext &&
    typeof window.PublicKeyCredential === 'function' &&
    typeof navigator.credentials?.get === 'function';
}

export function assertionPayload(assertion) {
  const response = {
    authenticatorData: bytesToBase64url(assertion.response.authenticatorData),
    clientDataJSON: bytesToBase64url(assertion.response.clientDataJSON),
    signature: bytesToBase64url(assertion.response.signature)
  };

  if (assertion.response.userHandle?.byteLength > 0) {
    response.userHandle = bytesToBase64url(assertion.response.userHandle);
  }

  return {
    id: assertion.id,
    rawId: bytesToBase64url(assertion.rawId),
    type: assertion.type,
    response
  };
}
